import { Input, InputNumber } from 'antd';
import React, { forwardRef, useState } from 'react';

const isZeroish = (v: any) =>
  v !== '' && v !== null && v !== undefined && Number(v) === 0;

interface ZeroBlankInputProps {
  asNumber?: boolean;
  value?: any;
  onChange?: (arg: any) => void;
  onFocus?: (e: any) => void;
  onBlur?: (e: any) => void;
  [key: string]: any;
}

const ZeroBlankInput = forwardRef<any, ZeroBlankInputProps>(
  ({ asNumber = false, value, onChange, onFocus, onBlur, ...rest }, ref) => {
    const [focused, setFocused] = useState(false);
    const [touched, setTouched] = useState(false);
    const blank = asNumber ? null : '';

    const display =
      focused && touched ? value : isZeroish(value) ? blank : value;

    const Comp: any = asNumber ? InputNumber : Input;
    return (
      <Comp
        ref={ref}
        {...rest}
        value={display}
        onFocus={(e: any) => {
          setFocused(true);
          setTouched(false);
          onFocus?.(e);
        }}
        onChange={(arg: any) => {
          setTouched(true);
          onChange?.(arg);
        }}
        onBlur={(e: any) => {
          setFocused(false);
          onBlur?.(e);
        }}
      />
    );
  },
);

ZeroBlankInput.displayName = 'ZeroBlankInput';

export default ZeroBlankInput;
